export default __webpack_public_path__ + "static/media/menu.e6efa12a.svg";